export default {
    bind: function(el) {
        el.event = function() {
            // Blur in bursts on a full animation frame, to avoid flicker
            requestAnimationFrame(() => el.blur())
        }
        el.addEventListener('mousedown', el.event)
    },

    unbind: function(el) {
        el.removeEventListener('mousedown', el.event)
    },
}
